import { connectedStore } from '../../store';
import actions from '../actions';

const saveMainLocale = (locale) =>
  new Promise((resolve, reject) => {
    const store = connectedStore.get();
    store.dispatch(actions.saveMainLocale(locale, resolve, reject));
  });

export default saveMainLocale;
